import React, { MouseEventHandler } from "react";
import { PageSize } from "api/model/dashboard/DashboardReportOptions";
import { T } from "services/lang/LanguageService";
import useIsMobile from "hooks/useIsMobile";
import { DashboardLayoutType, IDashboardComponent } from "api/model/dashboard/DashboardComponent";
import DashboardComponent from "../../group-component/GroupComponent";
import { ContextMenuItem } from "../interfaces";
import "../Layout.scss";

interface VerticalLayoutProps {
  components: IDashboardComponent[];
  tabId: number;
  align?: string;
  reportPageSize?: PageSize;
  layoutType: DashboardLayoutType;
  groupId: string;
  onContextMenu: MouseEventHandler<HTMLDivElement>;
  setCurrentContextMenuItems: (currentContextMenuItems: ContextMenuItem[]) => void;
}

const VerticalLayout = ({
  components,
  tabId,
  align,
  reportPageSize,
  layoutType,
  groupId,
  onContextMenu,
  setCurrentContextMenuItems,
}: VerticalLayoutProps) => {
  const isMobile = useIsMobile();

  const getComponentWidth = (component: IDashboardComponent) => {
    if (isMobile || component.type === "SEPARATOR") {
      return 12;
    }
    if (reportPageSize) {
      return null;
    }
    return component.layout?.VERTICAL?.width ?? 6;
  };

  const getComponentHeight = (component: IDashboardComponent) => {
    if (component.type === "NOT_SUPPORTED") {
      return 200;
    }
    return component.layout?.VERTICAL?.height ?? "100%";
  };

  return (
    <div key={groupId} className={`flex flex-column align-items-${align?.toLowerCase()} w-full`}>
      {components?.length > 0 ? (
        components.map(component => (
          <div
            key={component.id}
            onContextMenu={onContextMenu}
            className={`w-${getComponentWidth(component)} layout-wrapper vertical-layout ${reportPageSize && `border-1 border-round-sm`}`}
            style={{
              height: getComponentHeight(component),
              width: reportPageSize ? component.config.width : "auto",
            }}
          >
            <DashboardComponent
              groupId={groupId}
              tabId={tabId}
              component={component}
              layoutType={layoutType}
              setCurrentContextMenuItems={setCurrentContextMenuItems}
              isReports={!!reportPageSize}
            />
          </div>
        ))
      ) : (
        <div className="pl-3">{T("error.group-has-no-components")}</div>
      )}
    </div>
  );
};

export default VerticalLayout;
